<template>
  <div class="popup-menu">
    <VButton
        :disabled="paymentRequest.reasonUnavailableDeletePosition !== null"
        :title="paymentRequest.reasonUnavailableDeletePosition"
        @click="$emit('delete')"
    >
      <template #icon>
        <VIcon
            material="delete"
            theme="outlined"
        />
      </template>
      Удалить
    </VButton>
  </div>
</template>

<script lang="ts">
import type PaymentRequest from '@/domains/PaymentRequests/PaymentRequest';

export default defineComponent({
  name: 'PaymentRequestPositionContextMenu',

  props: {
    paymentRequest: {
      type: Object as PropType<PaymentRequest>,
      default: null,
    },
  },

  emits: ['delete'],
});
</script>